import { render, staticRenderFns } from "./RedRewardButton.vue?vue&type=template&id=5352d98c&scoped=true"
import script from "./RedRewardButton.vue?vue&type=script&lang=js"
export * from "./RedRewardButton.vue?vue&type=script&lang=js"
import style0 from "./RedRewardButton.vue?vue&type=style&index=0&id=5352d98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352d98c",
  null
  
)

export default component.exports